import { removeFromLocalStorage } from '@/shared'
import { removeFromSessionStorage } from '@/shared/lib/SessionStorage'
import { cacheClearAll } from '@/shared/api/request'

export const clearUserData = async () => {
	removeFromLocalStorage('isLogged')
	removeFromLocalStorage('activeRole')
	removeFromLocalStorage('roles')
	removeFromLocalStorage('activeCompany')
	removeFromLocalStorage('activeStaffBranch')
	removeFromSessionStorage('mio_check_done')

	await cacheClearAll()
}
